import React from 'react';
import BigText from '../c/BigText';

function TermsOfUse(props) {
	return (
		<div className="container ad_privacy_policy p-4">
			<BigText k="terms_of_use" fallback_lang="da"/>
		</div>
	);
}

export default TermsOfUse;



// WEBPACK FOOTER //
// ./src/p/TermsOfUse.js